import { GridToolbarContainer } from "@mui/x-data-grid";
import { EventosFinanceirosFilter } from "common/genericTypes";
import { Button } from "m2m.components";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { SaveAlt, SaveAltOutlined } from '@material-ui/icons';
import { Fade, Menu, MenuItem } from "@material-ui/core";
import { useState } from "react";

interface Props {
  filter: Array<EventosFinanceirosFilter>;
  inadimplente?: boolean;
  dataFrom?: Date | null;
  dataTo?: Date | null;
  linkOperator?: string;
}

const Toolbar: React.FC<Props> = (props) => {
  const { filter } = props;
  const postEventosFinanceirosApi = useSelector((state: RootState) => state.instrumentoApi.postEventosFinanceirosCsv);
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClose = () => { setAnchorEl(null) };
  const handleClick = (event: React.MouseEvent<HTMLElement>) => { setAnchorEl(event.currentTarget) };

  const exportAllRows = async (britech: boolean = false) => {
    const body = britech
      ? {
          page: 1,
          pageSize: 80000,
          eventosFinanceirosFilter: filter,
          britech: true
        }
      : {
          eventosFinanceirosFilter: props.filter,
          inadimplente: props.inadimplente,
          dataFrom: props.dataFrom,
          dataTo: props.dataTo,
          linkOperator: props.linkOperator,
          britech: false
        };

    const result = await postEventosFinanceirosApi(
      dispatch,
      body,
      true
    );

    const blobType = britech
      ? 'blob'
      : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

    const blob = new Blob([result], { type: blobType });
    const link = document.createElement('a');
    const href = window.URL.createObjectURL(blob);

    link.href = href;
    link.download = `Eventos_Financeiros_${britech ? 'Britech' : 'Laqus'}_${moment().format('DD-MM/YYYY')}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(href);
  }

  return (
    <GridToolbarContainer>
      <Button
        variant="text"
        onClick={handleClick}
        startIcon={<SaveAlt fontSize="medium" />}
      >
        Exportar
      </Button>
      <Menu
        id="fade-menu"
        MenuListProps={{
          'aria-labelledby': 'fade-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        <MenuItem onClick={() => exportAllRows(false)}>{"Padrão (Laqus)"}</MenuItem>
        <MenuItem onClick={() => exportAllRows(true)}>{"Padrão (Britech)"}</MenuItem>
      </Menu>
    </GridToolbarContainer>
  )
};

export default Toolbar;